"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  forBig: [{
    title: 'Product',
    links: [{
      name: 'About',
      path: 'https://www.dnv.com/software/digital-asset-ecosystem/digital-pipeline-ecosystem.html'
    }, {
      name: "What's new",
      path: '/news'
    }, {
      name: 'Blog',
      path: 'https://www.dnv.com/article/index.html'
    }, {
      name: 'Customer stories',
      path: 'https://www.dnv.com/software/cases.html'
    }]
  }, {
    title: 'Help and learning center',
    links: [{
      name: 'Contact support',
      path: 'https://www.dnv.com/software/software-services/software-support.html'
    }, {
      name: 'Videos and webinars',
      path: 'https://www.dnv.com/software/video-webinar/index.html'
    }, {
      name: 'User community',
      path: '/blog'
    }]
  }, {
    title: 'Legal',
    links: [{
      name: 'Privacy',
      path: 'https://www.dnv.com/privacy/index.html'
    }, {
      name: 'Terms of use',
      path: 'https://www.dnv.com/terms/index.html'
    }]
  }],
  forSmall: [{
    name: 'Contact support',
    path: 'https://www.dnv.com/software/software-services/software-support.html'
  }, {
    name: "What's new",
    path: '/news'
  }, {
    name: 'Videos and webinars',
    path: 'https://www.dnv.com/software/video-webinar/index.html'
  }],
  forSocialMedia: [{
    company: 'LinkedIn',
    href: 'https://www.linkedin.com/showcase/dnv-digital/'
  }, {
    company: 'Twitter',
    href: 'https://twitter.com/DNVGL_S'
  }, {
    company: 'Facebook',
    href: 'https://www.facebook.com/dnvglsoftware/'
  }, {
    company: 'Youtube',
    href: 'https://www.youtube.com/channel/UCbPgHOIo-gI2TKeZlB1L4fw'
  }]
};
exports.default = _default;